import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ColoredVolcanoIcon: React.FC<SvgIconProps> = ({ variant, ...props }) => {
  return (
    <SvgIcon {...props}>
      {variant == "outlined" ? (
        <>
          <path
            d="M1.79996 16.6932L2.17061 16.4998C5.57636 14.7229 8.37669 11.9732 10.2155 8.60043C10.3088 8.42917 10.515 8.35407 10.6967 8.42515L11.379 8.69216C11.9301 8.90781 12.5464 8.88255 13.078 8.62253L13.2992 8.51432C13.5498 8.39175 13.8524 8.47187 14.0095 8.70239L14.2784 9.09707C16.3785 12.1786 19.1198 14.7698 22.3147 16.6932M7.39487 12.9632L9.25805 12.5906C9.432 12.5558 9.57023 12.7531 9.48858 12.9106C9.2425 13.3851 8.93579 14.1441 9.25985 14.5038C9.72531 15.0206 10.5507 14.4107 10.9274 14.0806C10.9973 14.0194 11.1203 14.073 11.1229 14.1659C11.1382 14.7263 11.2812 15.9634 12.2438 15.9634C13.1542 15.9634 13.3813 14.8569 13.4377 14.2628C13.4473 14.1613 13.6045 14.1168 13.6663 14.1979C13.9987 14.6336 14.6656 15.3372 15.2278 14.8687C15.7065 14.4697 15.3177 13.4421 15.0517 12.8793C14.9789 12.7255 15.1113 12.5428 15.2788 12.5727L17.4657 12.9632"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke="black"
            fill="white"
          />
          <path
            d="M10.0827 5.97365V4.96803C10.0827 4.43462 9.89196 3.92305 9.5525 3.54587C9.21304 3.16869 8.75263 2.95679 8.27255 2.95679C7.79248 2.95679 7.33207 3.16869 6.9926 3.54587C6.65314 3.92305 6.46243 4.43462 6.46243 4.96803"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#ED8B18"
            fill="white"
          />
          <path
            d="M13.8126 5.97365V4.96803C13.8126 4.43462 14.0032 3.92305 14.3424 3.54587C14.6817 3.16869 15.1418 2.95679 15.6216 2.95679C16.1014 2.95679 16.5615 3.16869 16.9008 3.54587C17.24 3.92305 17.4306 4.43462 17.4306 4.96803"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#ED8B18"
            fill="white"
          />
          <path
            d="M11.9475 5.37024L11.9475 1.75"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#ED8B18"
            fill="white"
          />
          <path
            d="M2 22.7299H5.95898M5.95898 22.7299C5.95898 22.7299 7.36974 21.6667 8.11842 20.865C8.75467 20.1836 9.55805 19 9.55805 19M5.95898 22.7299H18.9156M15.3166 19C15.3166 19 16.1199 20.1836 16.7562 20.865C17.5049 21.6667 18.9156 22.7299 18.9156 22.7299M18.9156 22.7299H22.5147"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke="black"
          />
        </>
      ) : (
        <>
          <path
            d="M9.4581 13.2898L7.59492 13.6624L10.5789 9.72977L12.2 10.1992L13.7 9.69922L17.6658 13.6624L15.4788 13.2719C15.3113 13.242 15.179 13.4247 15.2517 13.5786C15.5177 14.1413 15.9066 15.169 15.4278 15.5679C14.8656 16.0364 14.1987 15.3328 13.8663 14.8971C13.8045 14.8161 13.6474 14.8605 13.6377 14.962C13.5814 15.5562 13.3543 16.6626 12.4438 16.6626C11.4812 16.6626 11.3383 15.4255 11.3229 14.8651C11.3204 14.7722 11.1974 14.7186 11.1275 14.7798C10.7507 15.1099 9.92535 15.7198 9.45989 15.2031C9.13583 14.8433 9.44254 14.0844 9.68862 13.6098C9.77028 13.4523 9.63204 13.255 9.4581 13.2898Z"
            fill="#ED8B18"
            fillOpacity="0.3"
          />
          <path
            d="M1.79996 16.6932L2.17061 16.4998C5.57636 14.7229 8.37669 11.9732 10.2155 8.60043C10.3088 8.42917 10.515 8.35407 10.6967 8.42515L11.379 8.69216C11.9301 8.90781 12.5464 8.88255 13.078 8.62253L13.2992 8.51432C13.5498 8.39175 13.8524 8.47187 14.0095 8.70239L14.2784 9.09707C16.3785 12.1786 19.1198 14.7698 22.3147 16.6932M7.39487 12.9632L9.25805 12.5906C9.432 12.5558 9.57023 12.7531 9.48858 12.9106C9.2425 13.3851 8.93579 14.1441 9.25985 14.5038C9.72531 15.0206 10.5507 14.4107 10.9274 14.0806C10.9973 14.0194 11.1203 14.073 11.1229 14.1659C11.1382 14.7263 11.2812 15.9634 12.2438 15.9634C13.1542 15.9634 13.3813 14.8569 13.4377 14.2628C13.4473 14.1613 13.6045 14.1168 13.6663 14.1979C13.9987 14.6336 14.6656 15.3372 15.2278 14.8687C15.7065 14.4697 15.3177 13.4421 15.0517 12.8793C14.9789 12.7255 15.1113 12.5428 15.2788 12.5727L17.4657 12.9632L13.5 9L12 9.5L10.3788 9.03055L7.39487 12.9632Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke="black"
            fill="white"
          />
          <path
            d="M10.0827 5.97365V4.96803C10.0827 4.43462 9.89196 3.92305 9.5525 3.54587C9.21304 3.16869 8.75263 2.95679 8.27255 2.95679C7.79248 2.95679 7.33207 3.16869 6.9926 3.54587C6.65314 3.92305 6.46243 4.43462 6.46243 4.96803"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#ED8B18"
            fill="white"
          />
          <path
            d="M13.8126 5.97365V4.96803C13.8126 4.43462 14.0032 3.92305 14.3424 3.54587C14.6817 3.16869 15.1418 2.95679 15.6216 2.95679C16.1014 2.95679 16.5615 3.16869 16.9008 3.54587C17.24 3.92305 17.4306 4.43462 17.4306 4.96803"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#ED8B18"
            fill="white"
          />
          <path
            d="M11.9475 5.37024L11.9475 1.75"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#ED8B18"
            fill="white"
          />
          <path
            d="M2 22.7299H5.95898M5.95898 22.7299C5.95898 22.7299 7.36974 21.6667 8.11842 20.865C8.75467 20.1836 9.55805 19 9.55805 19M5.95898 22.7299H18.9156M15.3166 19C15.3166 19 16.1199 20.1836 16.7562 20.865C17.5049 21.6667 18.9156 22.7299 18.9156 22.7299M18.9156 22.7299H22.5147"
            strokeWidth="1.5"
            strokeLinecap="round"
            stroke="black"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default ColoredVolcanoIcon;
